import { Quill } from "react-quill";
 
 class ChallengeBlot extends Quill.import("blots/block/embed") {
   static create(value) {
     let node = super.create();
     node.setAttribute("data-challenge", true);
     node.setAttribute("data-question", value.question || "");
     node.setAttribute("data-options", JSON.stringify(value.options || []));
     node.setAttribute("data-correct", JSON.stringify(value.correct || []));
 
     // Créer une carte Bootstrap pour l'interface du challenge
     const cardContainer = document.createElement("div");
     cardContainer.className = "challenge-container card";
 
     // Créer le corps de la carte
     const cardBody = document.createElement("div");
     cardBody.className = "card-body";
 
     // Ajouter la question
     const questionEl = document.createElement("h5");
     questionEl.className = "challenge-question card-title";
     questionEl.textContent = value.question;
 
     // Ajouter la description du challenge
     const description = document.createElement("p");
     description.className = "challenge-description card-text text-muted mb-3";
     description.textContent =
       "Sélectionnez la ou les bonnes réponses et validez pour tester vos connaissances.";
 
     // Conteneur des options
     const optionsContainer = document.createElement("div");
     optionsContainer.className = "challenge-options";
 
     // Créer les options sous forme de "form-check" cliquables
     value.options.forEach((option, index) => {
       const formCheck = document.createElement("div");
       formCheck.className = "form-check mb-2 challenge-option";
 
       const radio = document.createElement("input");
       radio.type = value.correct.length > 1 ? "checkbox" : "radio";
       radio.className =
         value.correct.length > 1
           ? "form-check-input challenge-checkbox"
           : "form-check-input challenge-radio";
       radio.name = "challenge-" + Math.random().toString(36).substr(2, 9);
       radio.id =
         "option-" + index + "-" + Math.random().toString(36).substr(2, 9);
       radio.dataset.index = index;
 
       const label = document.createElement("label");
       label.className = "form-check-label w-100";
       label.htmlFor = radio.id;
       label.textContent = option;
 
       formCheck.appendChild(radio);
       formCheck.appendChild(label);
 
       let lastSelectedRadio = null;
 
       // Rendre toute l'option cliquable
       formCheck.addEventListener("click", function (e) {
         // Éviter de déclencher deux fois si on clique sur le checkbox/radio directement
         if (e.target !== radio) {
           // Pour les cases à cocher, on bascule l'état
           if (radio.type === "checkbox") {
             radio.checked = !radio.checked;
           }
           // Pour les boutons radio, permettre désélection
           else if (radio.type === "radio") {
             if (lastSelectedRadio === radio && radio.checked) {
               radio.checked = false;
               lastSelectedRadio = null;
             } else {
               radio.checked = true;
               lastSelectedRadio = radio;
             }
           }
         } else if (radio.type === "radio") {
           // Si on clique directement sur le radio, mémoriser quel radio est sélectionné
           if (radio.checked) {
             lastSelectedRadio = radio;
           }
         }
 
         // Ajouter/enlever la classe "selected" pour le style visuel
         if (radio.checked) {
           formCheck.classList.add("selected");
         } else {
           formCheck.classList.remove("selected");
         }
       });
 
       optionsContainer.appendChild(formCheck);
     });
 
     // Ajouter le bouton de validation
     const buttonContainer = document.createElement("div");
     buttonContainer.className = "challenge-button-container mt-3";
 
     const validateBtn = document.createElement("button");
     validateBtn.className = "btn btn-primary challenge-validate";
     validateBtn.textContent = "Vérifier ma réponse";
 
     buttonContainer.appendChild(validateBtn);
 
     // Créer la zone de feedback
     const feedbackEl = document.createElement("div");
     feedbackEl.className = "challenge-feedback alert mt-3";
     feedbackEl.style.display = "none";
 
     // Assembler tous les éléments
     cardBody.appendChild(questionEl);
     cardBody.appendChild(description);
     cardBody.appendChild(optionsContainer);
     cardBody.appendChild(buttonContainer);
     cardBody.appendChild(feedbackEl);
 
     cardContainer.appendChild(cardBody);
 
     node.appendChild(cardContainer);
 
     return node;
   }
 
   static value(node) {
     return {
       question: node.getAttribute("data-question"),
       options: JSON.parse(node.getAttribute("data-options")),
       correct: JSON.parse(node.getAttribute("data-correct")),
     };
   }
 }
 
 ChallengeBlot.blotName = "challenge";
 ChallengeBlot.tagName = "div";
 ChallengeBlot.className = "challenge-wrapper";
 
 export default ChallengeBlot;